import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {createArticle, editArticle} from '../../../../components/requests'
import {useNavigate} from 'react-router-dom'

const validate = (values) => {
  const errors: {code?: string, commentaire?: string} = {}
  if (!values.code) {
    errors.code = 'Le code est requis'
  }
  if (!values.commentaire) {
    errors.commentaire = 'Le commentaire est requis'
  }
  return errors
}

const ArticleForm = ({id, data}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const insertOrUpdateArticle = (values) => {
    let action
    if (data === null) {
      action = createArticle(values)
    } else {
      action = editArticle(id, values)
    }
    action
      .then((response) => {
        if (response?.data !== undefined && response?.status === 200) {
          setIsLoading(false)
          navigate('/articles/liste')
        }
      })
      .catch((error) => {
        console.log('erreur')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const submitArticle = (values) => {
    setIsLoading(true)
    insertOrUpdateArticle(values)
  }

  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('code', data.code)
      formik.setFieldValue('commentaire', data.commentaire)
    }
  }, [data])

  const formik = useFormik({
    initialValues: {
      code: '',
      commentaire: '',
    },
    validate,
    onSubmit: (values) => {
      submitArticle(values)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Code</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'code'}
                    inputPlaceholder={'Code'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Commentaire</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'commentaire'}
                    inputPlaceholder={'Commentaire'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => {
              formik.resetForm()
              navigate(`/articles/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {ArticleForm}
